import { BitoshiHourForm } from "components/forms/BitoshiHourForm";
import AdminSidebar from "components/layout/AdminSidebar";
import Container from "components/layout/Container";
import Main from "components/layout/Main";
import { useNavigate } from "react-router-dom";
import { adminRoutes } from "routes/routes";

const CreateBitoshiHour: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container>
            <AdminSidebar />
            <Main className="mx-5 mt-5 text-left max-w-[1000px]">
                <div className="flex justify-between items-center mb-10">
                    <h2 className="text-2xl">Create Bitoshi Hour</h2>
                    <button
                        onClick={() => navigate(adminRoutes.bitoshiHour)}
                        className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                    >
                        Go Back
                    </button>
                </div>
                <BitoshiHourForm />
            </Main>
        </Container>
    );
};

export default CreateBitoshiHour;

